import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AvanceMetaMensual from "../components/administrador/general/avance_meta_mensual";
import NfurecolectadoVSmetaestablecida from "../components/administrador/general/Nfu_recolectado_VS_meta_establecida";
import GestiondeReciclajeNfu from "../components/administrador/general/gestion_de_reciclaje_Nfu";
import AvanceMetaTotalGauge from "../components/administrador/general/avance_meta_reciclaje";
import RecoleccionNfuProvincia from "../components/administrador/general/recoleccion_nfu_por_provincia";
import Aprovechamiento from "../components/administrador/general/aprovechamiento";
import NfuEntregadoTipo from "../components/administrador/general/nfu_entregado_tipo";
import OperationStatsCarousel from "../components/administrador/general/carusel";
import SolicitudesProvinciaBarChart from "../components/administrador/general/SolicitudesProvinciaBarChart";
import "../styles/administrador.css";

const General = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [mesSeleccionado, setMesSeleccionado] = useState(0);
  const [token, setToken] = useState(null);
  const [idAdministrador, setIdAdministrador] = useState(null);
  const location = useLocation();

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2018 + 1 },
    (_, i) => currentYear - i
  );
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tokenFromUrl = params.get("token");
    const idFromUrl = params.get("idAdministrador");

    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    }
    if (idFromUrl) {
      setIdAdministrador(parseInt(idFromUrl, 10));
    }
  }, [location.search]);

  return (
    <div className="dashboard-container">
      <div className="select-mes">
        <div className="select-row">
          <div className="select-item">
            <label>Año:</label>
            <select
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>
          <div className="select-item">
            <label>Mes:</label>
            <select
              value={mesSeleccionado}
              onChange={(e) =>
                setMesSeleccionado(
                  e.target.value === "acumulado" ? 0 : Number(e.target.value)
                )
              }
            >
              <option value="acumulado">Acumulado</option>
              {meses.map((m, index) => (
                <option key={index} value={index + 1}>
                  {m}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <OperationStatsCarousel
        year={year}
        mes={mesSeleccionado}
        token={token}
        idAdministrador={idAdministrador}
      />

      <div className="container-graficas">
        {/* <AvanceMetaMensual year={year} mes={mesSeleccionado} token={token} idAdministrador={idAdministrador} /> */}
        <AvanceMetaTotalGauge
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
        />
        <GestiondeReciclajeNfu
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
        />
        <NfurecolectadoVSmetaestablecida
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
        />
        <RecoleccionNfuProvincia
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
        />
        <SolicitudesProvinciaBarChart
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
        />
        <NfuEntregadoTipo
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
        />
        <Aprovechamiento
          year={year}
          mes={mesSeleccionado}
          token={token}
          idAdministrador={idAdministrador}
        />
      </div>
    </div>
  );
};

export default General;
